module.exports = __webpack_public_path__ + "img/selected6-min.264a8a7f.png";